import React, { useState, useEffect } from 'react';

interface GroqOptionsProps {
  settings: any;
  onSettingChange: (key: string, value: string) => void;
}

export const GroqOptions: React.FC<GroqOptionsProps> = ({ settings, onSettingChange }) => {
  const [inputValue, setInputValue] = useState(settings?.GroqApiKey || '');
  const [apiKey, setApiKey] = useState(settings?.GroqApiKey || '');
  const [customModels, setCustomModels] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function findCustomModels() {
      if (!apiKey || apiKey.length < 10) {
        setCustomModels([]);
        return;
      }

      setLoading(true);
      try {
        // Mock para simular busca de modelos - em produção seria uma chamada real à API
        await new Promise(resolve => setTimeout(resolve, 1000));
        
        // Simular modelos disponíveis do Groq
        const mockModels = [
          { id: 'llama3-8b-8192', name: 'Llama 3 8B (8K Context)' },
          { id: 'llama3-70b-8192', name: 'Llama 3 70B (8K Context)' },
          { id: 'mixtral-8x7b-32768', name: 'Mixtral 8x7B (32K Context)' },
          { id: 'gemma2-9b-it', name: 'Gemma2 9B Instruct' },
          { id: 'llama3.1-8b-instant', name: 'Llama 3.1 8B Instant' },
          { id: 'llama3.1-70b-vision', name: 'Llama 3.1 70B Vision' }
        ];
        
        setCustomModels(mockModels);
      } catch (error) {
        console.error('Erro ao buscar modelos:', error);
        setCustomModels([]);
      } finally {
        setLoading(false);
      }
    }

    findCustomModels();
  }, [apiKey]);

  const handleApiKeyChange = (value: string) => {
    setInputValue(value);
    onSettingChange('GroqApiKey', value);
  };

  const handleApiKeyBlur = () => {
    setApiKey(inputValue);
  };

  const handleModelChange = (value: string) => {
    onSettingChange('GroqModelPref', value);
  };

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Chave da API Groq
          </label>
          <input
            type="password"
            value={inputValue}
            onChange={(e) => handleApiKeyChange(e.target.value)}
            onBlur={handleApiKeyBlur}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="gsk_..."
            required
          />
          <p className="text-xs text-gray-500 mt-1">
            Sua chave de API do Groq
          </p>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Seleção do Modelo de Chat
          </label>
          {loading ? (
            <select
              disabled
              className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-100 text-gray-500"
            >
              <option>Carregando modelos disponíveis...</option>
            </select>
          ) : (
            <select
              value={settings?.GroqModelPref || ''}
              onChange={(e) => handleModelChange(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            >
              <option value="">Selecione um modelo</option>
              {customModels.length > 0 && (
                <optgroup label="Modelos Disponíveis">
                  {customModels.map((model) => (
                    <option key={model.id} value={model.id}>
                      {model.name}
                    </option>
                  ))}
                </optgroup>
              )}
            </select>
          )}
          <p className="text-xs text-gray-500 mt-1">
            Selecione o modelo Groq que deseja usar
          </p>
        </div>
      </div>

      {/* Informação sobre o Groq */}
      <div className="bg-green-50 border border-green-200 rounded-lg p-4">
        <div className="flex items-start">
          <div className="flex-shrink-0">
            <svg className="h-5 w-5 text-green-400" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
          </div>
          <div className="ml-3">
            <h3 className="text-sm font-medium text-green-800">
              Sobre o Groq
            </h3>
            <div className="mt-2 text-sm text-green-700">
              <p>
                O Groq oferece a inferência de LLM mais rápida disponível para aplicações de IA em tempo real.
                Ideal para chatbots que precisam de respostas rápidas e eficientes.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};



